var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartNotFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5H3.535L3.5 2.2075C3.42838 1.59951 3.13616 1.03895 2.67874 0.632062C2.22133 0.225186 1.63053 0.000285 1.01833 0H0V1.66667H1.01833C1.22244 1.6667 1.41945 1.74163 1.57198 1.87726C1.72451 2.0129 1.82195 2.19979 1.84583 2.4025L3.16667 13.6258C3.23829 14.2338 3.53052 14.7944 3.98793 15.2012C4.44534 15.6082 5.03614 15.8331 5.64834 15.8333H16.6666V14.1667H5.64834C5.44409 14.1667 5.24699 14.0916 5.09444 13.9557C4.94189 13.82 4.84453 13.6328 4.82084 13.43L4.71167 12.5H18.1966L20 2.5ZM16.8033 10.8333H4.51584L3.73167 4.16667H18.0058L16.8033 10.8333Z",
    fill: "#CB8D8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83334 20C6.75381 20 7.50001 19.2538 7.50001 18.3333C7.50001 17.4128 6.75381 16.6667 5.83334 16.6667C4.91286 16.6667 4.16667 17.4128 4.16667 18.3333C4.16667 19.2538 4.91286 20 5.83334 20Z",
    fill: "#CB8D8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 20C15.0871 20 15.8333 19.2538 15.8333 18.3333C15.8333 17.4128 15.0871 16.6667 14.1666 16.6667C13.2462 16.6667 12.5 17.4128 12.5 18.3333C12.5 19.2538 13.2462 20 14.1666 20Z",
    fill: "#CB8D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartNotFill);
export default __webpack_public_path__ + "static/media/Cart-not-fill.7035447dd9b73d2b68b9d26991f09d34.svg";
export { ForwardRef as ReactComponent };